###
Third party library initialization/setup
###
Raven = require('raven-js')
ngRaven = require('raven-js/plugins/angular')

clients = window.rjm.app.params?.clients
clientId = window.rjm.app.params?.clientId
client = null
userIdentity = window.rjm.app.params?.user?.identity or {}
featureFlags = window.rjm.app.params?.featureFlags

if clientId? and clients?
  client = _.find clients, (c) ->
    c.id is clientId

## Setup Raven intergration (sentry.io)
ravenOptions =
  ignoreUrls: [/localhost.test:5000\//i]
  ignoreErrors: ['QuotaExceededError']

tagsContext =
  tier: client?.featureTier

Raven.config('https://fb4dcdf23a2c42f5b2db82adaf3e3107@sentry.io/140184', ravenOptions)
 .addPlugin(ngRaven, angular)
 .setUserContext(
   email: userIdentity.email
   id: userIdentity.user_id
 )
 .setTagsContext(tagsContext)
 .install()


## Setup Intercom integration
if Intercom? and window.rjm.app.params?.user?.supportId is 0
  showIntercomLauncher = featureFlags["CHAT_SUPPORT"]? and featureFlags["CHAT_SUPPORT"]
  additionalTraits =
    featureTier: client?.featureTier
  userTraits = angular.extend(
    userIdentity or {},
    additionalTraits
  )
  
  Intercom('boot', userTraits)
  Intercom('update',
    hide_default_launcher: not showIntercomLauncher
  )
